export const MEMBER_URL = 'MEMBER_URL';
export const MEMBER_GET_FOLDER = 'MEMBER_GET_FOLDER';
export const MEMBER_SET_AGREE = 'MEMBER_SET_AGREE';
